import { apiIsomorphicFetchUserEnvironment } from '#/api/userEnvironment/apiFetchUserEnvironment';
import type { LayoutHandleProps } from '#/layouts/Layout/LayoutHandleProps';
import { redirectRequireAuthentication } from '#/modules/auth/routing/redirect-require-authentication';
import { UserDashboardViewEventPageLoadable } from '#/modules/userDashboard/pages/ViewEvent/UserDashboardViewEventPageLoadable';
import { userDashboardViewEventRoute } from '#/modules/userDashboard/routing/userDashboard.routes';
import type { HorizonAppRouteLoaderArgs } from '#/routing/classes/types/AppRouteLoaderArgs';
import type { HorizonAppRouteComponentProps } from '#/routing/types/HorizonAppRouteComponentProps';

export const handle = {
  darkBackground: true,
  fallbackUrlByLocaleToCurrent: true,
  showDesktopSearch: true,
} satisfies LayoutHandleProps;

export async function loader({
  request,
  context,
}: HorizonAppRouteLoaderArgs<typeof userDashboardViewEventRoute>) {
  const [{ user }] = await Promise.all([
    apiIsomorphicFetchUserEnvironment({
      request,
      context,
    })(),
    UserDashboardViewEventPageLoadable.load(),
  ]);

  if (!user) return redirectRequireAuthentication({ request });
}

export default function UserDashboardViewEventHorizonRoute(
  _: HorizonAppRouteComponentProps<typeof loader>,
) {
  return <UserDashboardViewEventPageLoadable />;
}
